import React from "react";
import { Flex, AspectRatio, Text } from "@chakra-ui/react";
import Image from "next/image";
import { Section } from "components/section";
import { TextLarge } from "ui/text";
import Balancer from "react-wrap-balancer";
import { AuraCard } from "ui/cards";
import forbesBestStartupEmployer from "../../../public/assets/company/careers/forbes.png";

export function ForbesAward() {
  return (
    <Section bg="white">
      <AuraCard variant="green">
        <Flex
          flexDir={{ base: "column", md: "row" }}
          align="center"
          maxW="5xl"
          mx="auto"
          gap={{ base: "bigger", md: "biggest", lg: "huge" }}
          textAlign={{ base: "center", md: "left" }}
          px={{ md: "smaller" }}
        >
          <AspectRatio ratio={1 / 1} w="100%" maxW={{ base: "160px", lg: "200px" }} position="relative">
            <Image
              fill
              sizes="100%"
              src={forbesBestStartupEmployer}
              alt="Forbes 2025: America's best startup employers, powered by statista."
              style={{ objectFit: "contain" }}
            />
          </AspectRatio>
          <TextLarge
            size="md"
            text={
              <Balancer>
                <Text as="span" fontWeight="normal">
                  Hightouch has been named America&rsquo;s
                </Text>{" "}
                #3 best startup employer{" "}
                <Text as="span" fontWeight="normal">
                  by Forbes
                </Text>
              </Balancer>
            }
          />
        </Flex>
      </AuraCard>
    </Section>
  );
}
